import { render, staticRenderFns } from "./itemCreate.vue?vue&type=template&id=627f6ec0&scoped=true"
import script from "./itemCreate.vue?vue&type=script&lang=js"
export * from "./itemCreate.vue?vue&type=script&lang=js"
import style0 from "./itemCreate.vue?vue&type=style&index=0&id=627f6ec0&prod&scoped=true&lang=css"
import style1 from "./itemCreate.vue?vue&type=style&index=1&id=627f6ec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627f6ec0",
  null
  
)

export default component.exports